import { ReactNode } from "react";
import classNames from "classnames";
import Slider from "react-slick";
import './Slick.css';
import './Rolling.css';

type RollingProps = { className?: string; elements: ReactNode[] };

export const Rolling = ({ className, elements }: RollingProps) => {
  return (
    <Slider
      className={classNames('rolling', className)}
      arrows={false}
      draggable={false}
      autoplaySpeed={2000}
      autoplay
      vertical
    >
      {elements.map((element, index) => (
        <span className="rolling-item" key={index}>{element}</span>
      ))}
    </Slider>
  )
}
